import { useState } from "react";

import { types } from "./definitions";

function useModalState(initIsOpen = false): types.ModalStateValues {
  const [isOpen, setModalIsOpen] = useState(initIsOpen);

  const openModal = (): void => {
    setModalIsOpen(true);
  };

  const closeModal = (): void => {
    setModalIsOpen(false);
  };

  const toggleModal = (modalOptions: types.ToggleModalProps): void => {
    setModalIsOpen(modalOptions.isOpen);
  };

  return {
    closeModal,
    isOpen,
    openModal,
    toggleModal,
  };
}

export default useModalState;
